import React from 'react';
import { ChooseWorkoutModal } from './Modals/ChooseWorkoutModal';
import { ChooseLeaderboardsModal } from './Modals/ChooseGeneralLeaderboardsModal';
import { selectItemsIds, chooseWorkoutItemsIds } from './constants';
import { ChooseYoutubeVideoModal } from './Modals/ChooseYoutubeVideoModal';
import AddWorkoutChallengeModal from '../AddWorkoutChallengeModal';

export const SecondStepFactory = ({ ...props }) => {
    switch (props.type) {
        case selectItemsIds.WORKOUT_EXERCISES:
        case selectItemsIds.WEARABLE_STATS:
        case selectItemsIds.WORKOUT_PLAYBACK:
            return <ChooseWorkoutModal itemId={props.type} notForLeaderboards={true} {...props} />;

        case selectItemsIds.GENERAL_LEADERBOARDS:
            return <ChooseLeaderboardsModal {...props} />;

        case selectItemsIds.WORKOUT_LEADERBOARDS:
            return <ChooseWorkoutModal {...props} />;

        case selectItemsIds.YOUTUBE_VIDEO:
            return <ChooseYoutubeVideoModal {...props} />;

        default:
            return null;
    }
};

export const ChooseWorkoutSecondStepFactory = ({ ...props }) => {
    switch (props.leaderboardsType) {
        case chooseWorkoutItemsIds.WORKOUT_OF_THE_DAY:
            return (
                <ChooseLeaderboardsModal workoutLeaderboards={true} title={'Choose workout leaderboards'} {...props} />
            );
        case chooseWorkoutItemsIds.CHALLENGE_OF_THE_WEEK:
            return (
                <ChooseLeaderboardsModal workoutLeaderboards={true} title={'Choose workout leaderboards'} {...props} />
            );
        case chooseWorkoutItemsIds.CUSTOM_WORKOUT:
            return (
                <AddWorkoutChallengeModal
                    title={'Choose custom workout'}
                    workoutLeaderboards={true}
                    isGymTv={true}
                    {...props}
                />
            );
        default:
            return null;
    }
};



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/SecondStepFactory.js